import { assign, omit, forEach, filter } from 'lodash';

import { DEFAULTS as WATERMARK } from '../enums/Watermark';
import { BEHAVIOR, PDF_CHAR_SETS_DEFAULT } from './Deal';
import Vital from './Vital';

// NB: this is not yet fully implemented, as template "status" is currently just binary based on the 'public' property,
// so these keys are not yet used... but Templates may have more steps soon.
// In the meantime we can lookup the public-facing names based on the value of the public property in this enum
export const TEMPLATE_STEPS = [
  { key: 'draft', public: false, name: 'Draft' },
  { key: 'active', public: true, name: 'Active' },
];

export const TEMPLATE_TYPES = {
  demand: { key: 'demand', name: 'DemandsAI' },
  'settlement-calculator': { key: 'settlement-calculator', name: 'Settlement Calculator' },
};

export default class Template {
  title = null;
  description = null;
  key = null;
  inbound = false;
  batch = false;
  inboundParty = null;
  inboundMulti = false; //whether multiple inbound deals of the same template type can be created
  autoParty = null;
  autoDealUser = null;
  guestSigning = BEHAVIOR.guestSigning.defaultValue;
  autoGuest = BEHAVIOR.autoGuest.defaultValue;
  commenting = BEHAVIOR.commenting.defaultValue;
  readonly = BEHAVIOR.readonly.defaultValue;
  showLetterhead = BEHAVIOR.showLetterhead.defaultValue;
  showTitle = BEHAVIOR.showTitle.defaultValue;
  pdfCharSet = PDF_CHAR_SETS_DEFAULT;
  theme = BEHAVIOR.theme.defaultValue;
  workflow = BEHAVIOR.workflow.defaultValue;
  public = false;
  dealID = null;
  integrations = null;
  team = null;
  excludeCL = false;
  watermark = WATERMARK;
  vitals = {};
  type = null;

  constructor(json, dealID) {
    assign(this, omit(json, 'vitals'));
    this.dealID = dealID;

    forEach(json.vitals, (vitalJSON, id) => {
      this.vitals[id] = new Vital(vitalJSON);
    });
  }

  get sourceTemplateKey() {
    return `${this.team || 'Outlaw'}:${this.key || 'unknown'}`;
  }

  get variableVitals() {
    return filter(this.vitals, {type: 'variable'});
  }

  get clauseVitals() {
    return filter(this.vitals, {type: 'clause'});
  }

  get json() {
    return omit(this, ['sourceTemplateKey', 'json']);
  }
}
